module.exports = __webpack_public_path__ + "static/media/qianbao.91b845e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/qianbao.png
// module id = 671
// module chunks = 2